import React from "react";
import moment from "moment";
import "moment/locale/bg";
import { useInput, ValidationError } from "react-admin";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

const CustomDateInput = props => {
  const {
    required,
    onChange,
    noTime,
    endOfDay,
    onBlur,
    readOnly,
    defaultValue,
    disabled,
    validate,
    source,
    minDate,
    maxDate,
    shouldDisableDate,
    style,
    ...rest
  } = props;

  const {
    field,
    fieldState: { isTouched, invalid, error },
    formState: { isSubmitted },
  } = useInput({
    onChange,
    onBlur,
    readOnly,
    disabled,
    source,
    defaultValue,
    validate,
    ...props,
  });

  // noTime sends a bare date; otherwise the day is stamped either at its start or - for fields that
  // close a period ("valid until", "ends on") - at its very end, so the whole day is included.
  const timeSuffix = noTime ? "" : endOfDay ? "T23:59:59" : "T00:00:00";

  const handleChange = date => {
    if (date) {
      field.onChange(`${date?.format("YYYY-MM-DD")}${timeSuffix}`);
    } else {
      field.onChange(null);
    }
  };

  const value = field?.value ? moment(field.value) : null;

  const errorMessage = invalid && error ? <ValidationError error={error?.message || error} /> : "";

  return (
    <LocalizationProvider
      dateAdapter={AdapterMoment}
      dateLibInstance={moment.utc}
      adapterLocale="bg"
    >
      <DatePicker
        {...field}
        label={props.label}
        format="DD-MM-YYYY"
        //source={source}
        value={value}
        onChange={handleChange}
        minDate={minDate ? moment(minDate) : undefined}
        maxDate={maxDate ? moment(maxDate) : undefined}
        shouldDisableDate={shouldDisableDate}
        error={(isTouched || isSubmitted) && invalid}
        helperText={(isTouched || isSubmitted) && invalid ? errorMessage : ""}
        readOnly={readOnly}
        disabled={disabled || readOnly}
        required={required}
        validate={validate}
        slotProps={{
          actionBar: {
            actions: ["clear"],
          },
          textField: {
            helperText: invalid ? errorMessage : "",
            label: required ? props.label + " *" : props.label,
            error: invalid,
            style,
            InputProps: {
              style: {
                color: invalid ? "#9D1B53;" : "",
              },
            },
          },
        }}
        {...rest}
      />
    </LocalizationProvider>
  );
};

export default CustomDateInput;
